import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { useState, type FormEvent } from 'react';
import { useAuth } from '../lib/auth';
import { Campo } from '../ui/campos';

export const Route = createFileRoute('/setup')({
  beforeLoad: ({ context }) => {
    if (!context.auth.setupNecessario) throw redirect({ to: context.auth.eu ? '/' : '/login' });
  },
  component: Setup,
});

function Setup() {
  const auth = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ escritorio: '', nome: '', email: '', senha: '' });
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);
  const set = (k: keyof typeof f) => (v: string) => setF((x) => ({ ...x, [k]: v }));

  async function enviar(e: FormEvent) {
    e.preventDefault();
    setErro(null);
    setEnviando(true);
    try {
      await auth.setup(f);
      await nav({ to: '/' });
    } catch (err) {
      setErro(err instanceof Error ? err.message : 'não foi possível configurar');
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="entrada">
      <div className="cartao">
        <div className="marca">
          <span className="logo-mark">SGC</span>
          <div><h1>Primeiro acesso</h1><div className="sub">crie o escritório e o administrador</div></div>
        </div>
        <form onSubmit={enviar}>
          {erro && <div className="alerta erro">{erro}</div>}
          <Campo rotulo="Nome do escritório" valor={f.escritorio} onChange={set('escritorio')} autoFocus required />
          <Campo rotulo="Seu nome" valor={f.nome} onChange={set('nome')} required />
          <Campo rotulo="E-mail" valor={f.email} onChange={set('email')} type="email" autoComplete="username" required />
          <Campo rotulo="Senha" valor={f.senha} onChange={set('senha')} type="password" autoComplete="new-password" ajuda="mínimo 8 caracteres, com letra e número" required />
          <button className="btn primario" type="submit" disabled={enviando}>{enviando ? 'criando…' : 'Criar escritório'}</button>
        </form>
      </div>
    </div>
  );
}
